<template>
    <v-app style="background-color: rgb(230, 230, 230);">

        <div class="pa-3 d-flex justify-center align-center" style="background-color: rgb(81, 120, 251);color:white;">
            <v-img class="mr-4" :src="require('@/assets/9manat-line-logo-01.png')" contain style="max-width:40px" />
            9 ma-nad
        </div>

        <v-dialog
            v-model="dialog_group"
            fullscreen
            hide-overlay
        >
            <v-card>

                <v-btn class="mr-4" icon @click="dialog_group = false" style="display: block;margin-left:auto;">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <div class="text-h4 mt-16"><b>เลือก Group</b></div>
                <v-list class="text-h6">
                    <v-list-item
                        align="center"
                        v-for="(item) in queuegroup"
                        :key="item.queue_group_id"
                    >
                        <v-list-item-content>
                            <v-btn class="mb-n3 text-h6" 
                            elevation="0"
                            x-large
                            outlined
                            style="'display:block;border-style: solid;border-radius: 10px;border-width: 2px;color: black !important;border-color: rgb(98, 194, 208)!important;"
                            color="primary" width="80%" @click="selectgroup(item.queue_group_id)">
                                {{ item.queue_group_name }}
                            </v-btn>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_edit_station_name"
        >
            <v-card>

                <v-card-title class="text-subtitle-1 grey lighten-2">
                    แก้ไขชื่อจุดให้บริการ
                </v-card-title>

                <v-card-text>
                    <v-text-field dense hide-details v-model="edit_station_name" outlined class="mt-4"></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large rounded color="primary" @click="click_edit_station_name">
                    ยืนยัน
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_edit_queue_announcement"
        >
            <v-card>

                <v-card-title class="text-subtitle-1 grey lighten-2">
                    แก้ไขข้อความแสดงผลบนหน้าจอ
                </v-card-title>

                <v-card-text>
                    <v-text-field dense hide-details v-model="edit_queue_announcement" outlined class="mt-4"></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large rounded color="primary" @click="click_edit_queue_announcement">
                    ยืนยัน
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_edit_queue_url"
        >
            <v-card>

                <v-card-title class="text-subtitle-1 grey lighten-2">
                    แก้ไข RICH MENU URL
                </v-card-title>

                <v-card-text>
                    <v-text-field dense hide-details v-model="edit_queue_url" outlined class="mt-4"></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large rounded color="primary" @click="click_edit_queue_url">
                    ยืนยัน
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_edit_queue_group_1"
        >
            <v-card>

                <v-card-title class="text-subtitle-1 grey lighten-2">
                    แก้ไขชื่อกลุ่มบัตรคิว (1)
                </v-card-title>

                <v-card-text>
                    <v-text-field dense hide-details v-model="edit_group_name_1" outlined class="mt-4"></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large rounded color="primary" @click="click_edit_queue_group_1">
                    ยืนยัน
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_edit_queue_group_2"
        >
            <v-card>

                <v-card-title class="text-subtitle-1 grey lighten-2">
                    แก้ไขชื่อกลุ่มบัตรคิว (2)
                </v-card-title>

                <v-card-text>
                    <v-text-field dense hide-details v-model="edit_group_name_2" outlined class="mt-4"></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large rounded color="primary" @click="click_edit_queue_group_2">
                    ยืนยัน
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_edit_queue_group_3"
        >
            <v-card>

                <v-card-title class="text-subtitle-1 grey lighten-2">
                    แก้ไขชื่อกลุ่มบัตรคิว (3)
                </v-card-title>

                <v-card-text>
                    <v-text-field dense hide-details v-model="edit_group_name_3" outlined class="mt-4"></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large rounded color="primary" @click="click_edit_queue_group_3">
                    ยืนยัน
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

            <v-window
                v-model="menu_val"
                style="overflow:scroll;height: 80%;background-color: rgb(230, 230, 230);"
            >
                <v-window-item
                    style="height: 100%;background-color: rgb(230, 230, 230);"
                    v-for="n in 3"
                    :key="`card-${n}`"
                >
                    <div v-if="menu_val==0" style="height: 100%;background-color: rgb(230, 230, 230);">
                        <div class="ma-6" style="border-color: rgb(98, 194, 208);border-style: solid;border-radius: 25px;">
                            <v-row>
                                <v-col cols="7">
                                    <div class="text-h6">กำลังเรียกคิว</div>
                                    <div class="text-h4"><b>{{ queuecall.queue_number }}</b></div>
                                    <div v-if="current_queue_group_id==0">{{ queuecall.queue_group_name }}</div>
                                </v-col>
                                <v-col cols="5">
                                    <img :src="queuecall.line_logo" style="border-radius: 50%;border-color: rgb(220, 223, 240);border-style: solid;max-width: 72px;" />
                                </v-col>
                            </v-row>
                        </div>
                        <div class="mt-n10 mx-8" style="background-color: rgb(255, 255, 255);border-color: rgb(98, 194, 208);border-style: solid;border-radius: 25px">
                            <b class="text-h6">{{ current_queue_group_name }}</b>
                        </div>

                        <v-divider class="mt-1" style="border-color:white;"></v-divider>
                        <v-list style="height: 45%;overflow: scroll;background-color: rgb(230, 230, 230);overflow-x: hidden;">
                            <v-list-item
                                v-for="(item) in queuelist"
                                :key="item.id"
                                class="mx-n4"
                                style="display: block;"
                            >
                                <div>
                                    <v-row class="mb-n4" style="background-color: rgb(230, 230, 230);align-items: center;">
                                        <v-col cols="3">
                                            <img :src="item.line_logo" style="border-radius: 50%;border-color: rgb(220, 223, 240);border-style: solid;max-width: 48px;" />
                                        </v-col>
                                        <v-col v-if="current_queue_group_id>0" cols="5">
                                            <div>Time</div>
                                            <div>{{ item.queue_datetime_created.substring(11,16) }}</div>
                                        </v-col>
                                        <v-col v-else cols="5">
                                            <div>{{ item.queue_group_name }}</div>
                                            <div>Time {{ item.queue_datetime_created.substring(11,16) }}</div>
                                        </v-col>
                                        <v-col cols="4">
                                            <b class="text-h4">{{ item.queue_number }}</b>
                                        </v-col>
                                    </v-row>
                                    <v-divider style="border-color:white;"></v-divider>
                                </div>
                            </v-list-item>
                        </v-list>

                        <div class="mt-1" style="width:90%;border-color: rgb(98, 194, 208);border-style: solid;border-radius: 10px;align-items: center;display: inline-flex;">
                            <div style="margin:auto;">จำนวนรอคิวใน Group นี้</div>
                            <div><b class="text-h4" style="margin:auto;color: rgb(80, 144, 208);">></b></div>
                            <div style="margin:auto;">{{ queuelist.length }}</div>
                        </div>

                        <div class="d-flex mt-3 justify-space-around" align="center">
                            <v-btn large rounded style="color:white;background-color: rgb(78, 201, 219);"  width="20%" @click="dialog_group = true">
                                Group
                            </v-btn>
                            <v-btn large rounded style="color:white;background-color: rgb(81, 120, 249);"  width="20%" @click="cmd('call' + current_queue_group_id)">
                                Call
                            </v-btn>
                        </div>
                    </div>

                    <div v-if="menu_val==1" style="background-color: rgb(230, 230, 230);">
                        <div class="text-subtitle-2 mt-6" style="color:rgb(133, 133, 135);">การตั้งค่า</div>
                        <div class="my-2">
                            <v-img :src="logo" contain style="margin:auto;border-radius: 50%;border-color: rgb(220, 223, 240);border-style: solid;max-width: 96px;" />
                            <!--<v-btn tile icon style="background-color: rgb(255, 255, 255);border-radius: 50%; position: absolute;top: 13%;right: 35%;">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>-->
                        </div>
                        <div class="d-flex justify-space-between mx-8 text-h5" style="background-color: rgb(255, 255, 255);border-color: rgb(98, 194, 208);border-style: solid;border-radius: 25px">
                            <div class="align-self-center" style="margin:auto;">{{ station_name }}</div>
                            <v-btn class="align-self-center" tile icon @click="dialog_edit_station_name=true">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </div>
                        <div>
                            <v-switch class="openshopinput" 
                                v-model="queue_enable"
                                inset
                                @change="click_edit_queue_enable"
                            ></v-switch>
                        </div>
                        <div class="text-h5" style="color:rgb(133, 133, 135);">
                            <div v-if="queue_enable">ระบบคิวเปิดอยู่</div>
                            <div v-if="!queue_enable">ระบบคิวปิดอยู่</div>
                        </div>
                        <div class="ma-6" style="background-color: rgb(255, 255, 255);border-color: rgb(98, 194, 208);border-style: solid;border-radius: 10px;">
                            <v-row>
                                <v-col cols="9" style="align-self: center;">
                                    <a :href="queue_url" v-if="queue_url.length>0">RICH MENU URL</a>
                                    <div v-else>ไม่มี RICH MENU URL</div>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn class="align-self-center" tile icon @click="dialog_edit_queue_url=true">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="text-subtitle-2" style="color:rgb(133, 133, 135);">ข้อความแสดงผลบนหน้าจอ</div>
                        <div class="d-flex justify-space-between mx-8" style="background-color: rgb(255, 255, 255);border-color: rgb(98, 194, 208);border-style: solid;border-radius: 25px">
                            <div class="align-self-center" style="margin:auto; overflow: hidden;">{{ queue_announcement }}</div>
                            <v-btn class="align-self-center" tile icon @click="dialog_edit_queue_announcement=true">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </div>
                        <div class="text-subtitle-2 mt-6" style="color:rgb(133, 133, 135);">กลุ่มที่ให้บริการออกบัตรคิว</div>
                        <div class="mx-6 mt-2 text-h6 pl-4" style="background-color: rgb(255, 255, 255);border-color: rgb(255, 255, 255);border-style: solid;border-radius: 10px;">
                            <v-row>
                                <v-col cols="7" style="text-align: left;">
                                    {{ queuegroup[0].queue_group_name }}
                                </v-col>
                                <v-col cols="2">
                                    <v-btn class="align-self-center" tile icon @click="dialog_edit_queue_group_1=true">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="3">
                                    <v-switch
                                        class="mt-1"
                                        v-model="is_enable_1"
                                        hide-details
                                        @change="click_edit_queue_group_1"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="mx-6 mt-2 text-h6 pl-4" style="background-color: rgb(255, 255, 255);border-color: rgb(255, 255, 255);border-style: solid;border-radius: 10px;">
                            <v-row>
                                <v-col cols="7" style="text-align: left;">
                                    {{ queuegroup[1].queue_group_name }}
                                </v-col>
                                <v-col cols="2">
                                    <v-btn class="align-self-center" tile icon @click="dialog_edit_queue_group_2=true">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="3">
                                    <v-switch
                                        class="mt-1"
                                        v-model="is_enable_2"
                                        hide-details
                                        @change="click_edit_queue_group_2"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="mx-6 mt-2 mb-8 text-h6 pl-4" style="background-color: rgb(255, 255, 255);border-color: rgb(255, 255, 255);border-style: solid;border-radius: 10px;">
                            <v-row>
                                <v-col cols="7" style="text-align: left;">
                                    {{ queuegroup[2].queue_group_name }}
                                </v-col>
                                <v-col cols="2">
                                    <v-btn class="align-self-center" tile icon @click="dialog_edit_queue_group_3=true">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="3">
                                    <v-switch
                                        class="mt-1"
                                        v-model="is_enable_3"
                                        hide-details
                                        @change="click_edit_queue_group_3"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            
                        </div>
                        <div style="color:rgb(230, 230, 230);">a</div>
                    </div>
                    <div v-if="menu_val==2" style="background-color: rgb(230, 230, 230);">
                        <div class="mb-2 mt-12">
                            <v-img :src="logo" contain style="margin:auto;border-radius: 50%;border-color: rgb(220, 223, 240);border-style: solid;max-width: 96px;" />
                        </div>
                        <div class="text-h5" style="margin:auto;"><b>{{ station_name }}</b></div>

                        <div class="ma-6" style="background-color: rgb(255, 255, 255);border-color: rgb(98, 194, 208);border-style: solid;border-radius: 15px;">
                        <v-row>
                            <v-col cols="9" style="align-self: center;">
                                <a :href="queue_url" v-if="queue_url.length>0">RICH MENU URL</a>
                                <div v-else>ไม่มี RICH MENU URL</div>
                            </v-col>
                            <v-col cols="3">
                                <v-btn class="align-self-center" tile icon @click="dialog_edit_queue_url=true">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="ma-2" style="background-color: rgb(255, 255, 255);border-color: rgb(98, 194, 208);border-style: solid;border-radius: 15px;">
                        <div>วันเวลาที่ซื้อคิวล่าสุด</div>
                        <div>yyyy/mm/dd hh:mm</div>
                        <v-row>
                            <v-col cols="4">
                                คิวคงเหลือ
                            </v-col>
                             <v-col cols="2">
                                 >
                            </v-col>
                            <v-col cols="6">
                                0
                            </v-col>
                        </v-row>
                    </div>
                    </div>

                    

                </v-window-item>
            </v-window>

        <v-bottom-navigation
            :value="menu_val"
            color="teal"
            grow
            style="position:fixed;"
        >
            <v-btn @click="menu_val=0">
                <!--<span>Recents</span>-->
                <v-icon class="text-h4">mdi-bell</v-icon>
            </v-btn>

            <v-btn @click="menu_val=1">
                <v-icon class="text-h4">mdi-cog</v-icon>
            </v-btn>

            <v-btn @click="menu_val=2">
                <v-icon class="text-h4">mdi-menu</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </v-app>
</template>

<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
    font-family: SukhumvitSet !important
}
.v-application .text-h5,.v-application .text-h3,.v-application .text-h1, .v-application .text-h4,.v-application .text-h6,.v-application .text-body-2,.v-application .text-caption,.v-application .text-subtitle-2,.v-application .text-subtitle-1{
    font-family: SukhumvitSet !important
}
.openshopinput .v-input--selection-controls__input {
    height: 36px !important;
    width: 108px !important;
}
.openshopinput .v-input--switch__track {
    height: 36px;
    width: 108px;
}
.openshopinput .v-input--switch__thumb {
    height: 28px;
    width: 28px;
}
.v-application--is-ltr .v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb{
    transform: translate(70px, 0) !important;
}
.v-input--selection-controls__ripple {
    height: 0px;
    width: 0px;
}
.openshopinput .v-input__slot {
        justify-content: center;
}
</style>

<script>

import axios from 'axios';
import config from '@/../config.js'
import Member from '@/models/instance/Member'

export default {
  data () {
    return {
        menu_val : 0
        ,dialog_newcmd : false
        ,cmdlist : [{id:11,name:'EPR 11'},{id:12,name:'EPR 12'},{id:13,name:'EPR 13'},{id:14,name:'EPR 14'}]
        ,status : []

        ,dialog_group : false
        ,queuegroup : []
        ,current_queue_group_id : 0
        ,current_queue_group_name : "All Group"

        ,dialog_edit_station_name : false
        ,dialog_edit_queue_announcement : false
        ,dialog_edit_queue_url : false
        ,station_name : ""
        ,edit_station_name : ""
        ,logo: require('@/assets/logo-default.jpg')
        ,queue_enable : true
        ,queue_announcement : ""
        ,edit_queue_announcement : ""
        ,queue_url : ""
        ,edit_queue_url : ""
        ,edit_group_name_1 : ""
        ,edit_group_name_2 : ""
        ,edit_group_name_3 : ""
        ,dialog_edit_queue_group_1 : false
        ,dialog_edit_queue_group_2 : false
        ,dialog_edit_queue_group_3 : false
        ,is_enable_1 : true
        ,is_enable_2 : true
        ,is_enable_3 : true

        ,queuelist : []
        ,queuecall : {}

    }
  },
  mounted : function () {
    this.reload()
    const self = this
    setInterval(function() {
        self.background_reload()
    },1000*10)
  },
  methods : {
    selectgroup(queue_group_id){
        this.queuecall = {}
        this.queuegroup.forEach((g)=>{
            if(g.queue_group_id==queue_group_id){
                this.current_queue_group_id = g.queue_group_id
                this.current_queue_group_name = g.queue_group_name
            }
        })
        this.dialog_group = false
        this.reload()
    },
    background_reload(){
        axios
        .post(config.api.url.line.queue.get_managequeuelist
            ,{
                station_code:this.$route.params.station_code
                ,queue_group_id:this.current_queue_group_id
            }
            ,{ headers: Member.getTokenHeader()}
        )
        .then(response_queuelist => {
            var ql = []
            response_queuelist.data.forEach((q)=>{
                q.queue_group = q.queue_group.split('=')
                q.queue_group = q.queue_group[0]
                this.queuegroup.forEach(g=>{
                    if(g.queue_group_id==q.queue_group){
                        q.queue_group_name = g.queue_group_name
                    }
                })
                if(q.queue_status_id == 2){
                    this.queuecall = q
                }
                if(q.queue_status_id == 1){
                    ql.push(q)
                }
            })
            this.queuelist = ql
        })
    },
    reload(){
        /*var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.line.queue.get_managestatus
            ,{station_code:this.$route.params.station_code}
            ,{ headers: Member.getTokenHeader()}
        )
        .then(response => {
            this.status = response.data
            console.log(response.data)
            this.$store.commit('finishLoading',que)
        })*/
        var que = this.$store.commit('addLoading')   
        axios
        .post(config.api.url.public.queue.get_queuegroup
            ,{station_code:this.$route.params.station_code}
        ).then(response_queuegroup => {


            this.queuegroup = response_queuegroup.data
            this.is_enable_1 = (this.queuegroup[0].is_enable == 1)
            this.is_enable_2 = (this.queuegroup[1].is_enable == 1)
            this.is_enable_3 = (this.queuegroup[2].is_enable == 1)
            this.edit_group_name_1 = this.queuegroup[0].queue_group_name
            this.edit_group_name_2 = this.queuegroup[1].queue_group_name
            this.edit_group_name_3 = this.queuegroup[2].queue_group_name
            this.queuegroup = [{
                queue_group_name : 'All Group'
                ,queue_group_id : 0
                ,is_enable : true
            }].concat(this.queuegroup);

            axios
            .post(config.api.url.public.queue.get_stationdetail
                ,{station_code:this.$route.params.station_code}
            ).then(response_stationdetail => {
                console.log(response_stationdetail.data)

                this.station_name = response_stationdetail.data.station_name
                this.edit_station_name = response_stationdetail.data.station_name
                if(response_stationdetail.data.logo.length>0) this.logo = response_stationdetail.data.logo
                this.queue_enable = response_stationdetail.data.queue_enable == 'true'
                this.queue_announcement = response_stationdetail.data.queue_announcement
                this.edit_queue_announcement = response_stationdetail.data.queue_announcement
                this.queue_url = response_stationdetail.data.queue_url
                this.edit_queue_url = response_stationdetail.data.queue_url

                axios
                .post(config.api.url.line.queue.get_managequeuelist
                    ,{
                        station_code:this.$route.params.station_code
                        ,queue_group_id:this.current_queue_group_id
                    }
                    ,{ headers: Member.getTokenHeader()}
                )
                .then(response_queuelist => {
                    
                    this.$store.commit('finishLoading',que)

                    var ql = []
                    response_queuelist.data.forEach((q)=>{

                        q.queue_group = q.queue_group.split('=')
                        q.queue_group = q.queue_group[0]
                        this.queuegroup.forEach(g=>{
                            if(g.queue_group_id==q.queue_group){
                                q.queue_group_name = g.queue_group_name
                            }
                        })

                        if(q.queue_status_id == 2){
                            this.queuecall = q
                        }
                        if(q.queue_status_id == 1){
                            ql.push(q)
                        }
                    })
                    this.queuelist = ql
                    console.log(this.queuelist)
                })
            })
        })
    },newcmd(){
        this.dialog_newcmd = true
    },
    cmd(id){
        this.dialog_newcmd = false
        var que = this.$store.commit('addLoading')
        axios
            .post(config.api.url.line.queue.add_cmd
            ,{station_code:this.$route.params.station_code,cmdid:id}
            ,{ headers: Member.getTokenHeader()}
        ).then(response => {
            this.$store.commit('finishLoading',que)
            if(response.data.isSuccess){
                this.reload()
            }
        })
    },
    click_edit_station_name(){
        this.dialog_edit_station_name = false
        var que = this.$store.commit('addLoading')
        axios
            .post(config.api.url.line.queue.edit_stationname
            ,{station_code:this.$route.params.station_code,station_name:this.edit_station_name}
            ,{ headers: Member.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        })
    },
    click_edit_queue_announcement(){
        this.dialog_edit_queue_announcement = false
        var que = this.$store.commit('addLoading')
        axios
            .post(config.api.url.line.queue.edit_queueannouncement
            ,{station_code:this.$route.params.station_code,queue_announcement:this.edit_queue_announcement}
            ,{ headers: Member.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        })
    },
    click_edit_queue_url(){
        this.dialog_edit_queue_url = false
        var que = this.$store.commit('addLoading')
        axios
            .post(config.api.url.line.queue.edit_queueurl
            ,{station_code:this.$route.params.station_code,queue_url:this.edit_queue_url}
            ,{ headers: Member.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        })
    },
    click_edit_queue_enable(){
        this.dialog_edit_queue_enable = false
        var que = this.$store.commit('addLoading')
        axios
            .post(config.api.url.line.queue.edit_queueenable
            ,{station_code:this.$route.params.station_code,queue_enable:this.queue_enable}
            ,{ headers: Member.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        })
    },
    click_edit_queue_group_1(){
        this.dialog_edit_queue_group_1 = false
        var que = this.$store.commit('addLoading')
        axios
            .post(config.api.url.line.queue.edit_queuegroup
            ,{
                station_code:this.$route.params.station_code
                ,queue_group_id:this.queuegroup[0].queue_group_id
                ,queue_group_name:this.edit_group_name_1
                ,is_enable:this.is_enable_1 ? 1 : 0
            }
            ,{ headers: Member.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        })
    },
    click_edit_queue_group_2(){
        this.dialog_edit_queue_group_2 = false
        var que = this.$store.commit('addLoading')
        axios
            .post(config.api.url.line.queue.edit_queuegroup
            ,{
                station_code:this.$route.params.station_code
                ,queue_group_id:this.queuegroup[1].queue_group_id
                ,queue_group_name:this.edit_group_name_2
                ,is_enable:this.is_enable_2 ? 1 : 0
            }
            ,{ headers: Member.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        })
    },
    click_edit_queue_group_3(){
        this.dialog_edit_queue_group_3 = false
        var que = this.$store.commit('addLoading')
        axios
            .post(config.api.url.line.queue.edit_queuegroup
            ,{
                station_code:this.$route.params.station_code
                ,queue_group_id:this.queuegroup[2].queue_group_id
                ,queue_group_name:this.edit_group_name_3
                ,is_enable:this.is_enable_3 ? 1 : 0
            }
            ,{ headers: Member.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        })
    },
  }
}
</script>